module.exports = __webpack_public_path__ + "img/bandicam_00015.818c8bc5.png";